import { render } from "./DetailedScores.vue?vue&type=template&id=42fc6a25"
import script from "./DetailedScores.vue?vue&type=script&lang=js"
export * from "./DetailedScores.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__